<template>
  <div class="advertisement">
    <!-- 相关视频 -->
    
    <div class="surgery_video" v-if="num.video">
      <div class="express_rtitle">
        <div class="waike">相关视频</div>
        <div class="zi">MORE></div>
        <div class="waixian"></div>
      </div>
      <div class="surgery_bottom">
        <div v-for="(item,index) in video" :key="index" class="surgery_bottom1" v-if="index<3" @mouseover="addtop5(1,item.id)"
          @mouseout="addtop5(2,item.id)">
          <img src="/src/assets/tu5.jpg" alt="">
          <div class="surgery_bottomtxt" :class="item.zt?'add1':''">{{item.txt}}</div>
          <div class="surgery_bottomtxt2">
            <div class="surgery_one">手术者: {{item.name}}</div>
            <div class="surgery_two">{{item.num}}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 精彩视频 -->
    <!-- <div class="Journalism_one" v-if="num.video2">
      <div class="express_right">
        <div class="express_rtitle" style="padding-bottom: 0;">
          <div class="waike" style="width: auto;display: inline-block;padding-bottom: 8px;">精彩视频</div>
          <div class="zi" @click="jumpwai">MORE></div>
        </div>
        <div class="express_rxia" @click="jumpwai1">
          <img :src="titlePhoto" alt="" class="express_rimg" @click="jumpspxq(contentId)">
          <div class="express_rtxt" @click="jumpspxq(contentId)">{{title3}}</div>
          <div class="express_rlist" v-for="(item,index) in video2" :key="index" v-if="index<3 && index>0" @mouseover="addtop6(1,index)"
            @mouseout="addtop6(2,index)" @click="jumpspxq(item.contentId)">
            <div class="express_dian" :class="item.zt?'add2':''"></div>
            <div class="wenben" :class="item.zt?'add1':''">{{item.title}}</div>
          </div>
        </div>
      </div>
    </div> -->

    <!-- 外科天地 -->
    <div class="express_right" v-if="num.wai">
      <div class="express_rtitle">
        <div class="waike">精彩视频</div>
        <div class="zi">MORE></div>
        <div class="waixian"></div>
      </div>
      <div class="express_rxia">
        <img src="/src/assets/tu5.jpg" alt="" class="express_rimg">
        <div class="express_rtxt">多西他赛对进展期胃癌术后化疗疗效影...</div>
        <div class="express_rlist" v-for="(item,index) in list2" :key="index" v-if="index<2" @mouseover="addtop2(1,item.id)"
          @mouseout="addtop2(2,item.id)">
          <div class="express_dian" :class="item.zt?'add2':''"></div>
          <div class="wenben" :class="item.zt?'add1':''">{{item.txt}}</div>
        </div>
      </div>
    </div>
    
    <!-- 最新资讯 -->
    <!-- <div class="Journalism_one" v-if="num.zixun">
      <div class="express_rtitle">
        <div class="waike">最新资讯</div>
        <div class="waixian"></div>
      </div>
      <div class="Journalism_onebottom">
        <div class="Journalism_list" style="cursor: pointer;" @click="jumpzixun(7,zixuncontentId,zixunchannelId)">
          <img :src="zixuntu" class="Journalism_listl" />
          <div class="Journalism_listr">
            <div style="color: #000000;" class="cao">{{zixuntitle}}</div>
            <div class="listr_xia">
              <span style="margin-right: 20px;">来源：{{zixunname}}</span>
            </div>
          </div>
        </div>
        <div v-for="(item,index) in zixun" :key="index" class="Journalism_list2" v-if="index<6 && index>0" @mouseover="addtop7(1,index)" @mouseout="addtop7(2,index)" @click="jumpzixun(7,item.contentId,item.channelId)">
          <div :class="index<3?'Journalism_list2id':'Journalism_list2id2'">{{index+1}}</div>
          <div class="Journalism_list2txt"><span style="margin-right: 10px;" :class="item.zt?'add1':''">{{item.title}}</span></div>
        </div>
      </div>
    </div> -->

    <!-- 信息公告 -->
    <div class="express_nav2" v-if="num.xia">
        <div class="express_rtitle">

            <div style="marginLeft:10px;">
            <img style="float:left"  src="../../../assets/xxgg.png" alt="">
            </div>

          <div class="waikeaa">
            信息公告
          </div>

          <div style="float:right;lineHeight:30px;">
              更多>
          </div>
          <!-- <div class="waixian"></div> -->
        </div>
        
        <div class="express_nav2r">
          <div class="express_list2" v-for="(item,index) in xinxi" :key="index" v-if="index<7" @click="jump(item.year,item.issue,item.id)">
            
            <div class="express_dian" :class="item.zt?'add2':''" @mouseover="addtop33(1,item.id)" @mouseout="addtop33(2,item.id)"></div>
            <div class="express_wen" @mouseover="addtop33(1,item.id)" @mouseout="addtop33(2,item.id)" style="overflow: hidden;width: 87%;">

              <div class="wen11" :class="item.zt?'add1':''" style="float: left;">
                <span class="span4" :class="item.zt?'add1':''">{{item.title}}</span>
                </div>
            </div>
          </div>
        </div>
      </div>

    <!-- 下载排行 -->
    <div class="express_nav2" v-if="num.xia">
      <div class="express_rtitle">


            <div style="marginLeft:10px;">
            <img style="float:left"  src="../../../assets/xz.png" alt="">
            </div>

        <div class="waikebb">下载排行</div>
        <div style="float:right;lineHeight:30px;">
              更多>
          </div>
      </div>
      <div class="express_nav2r">
        <div class="express_list2" v-for="(item,index) in xia" :key="index" v-if="index<8" @click="jump(item.year,item.issue,item.id)">
          <div class="express_dian" :class="item.zt?'add2':''" @mouseover="addtop3(1,item.id)" @mouseout="addtop3(2,item.id)"></div>
          <div class="express_wen" @mouseover="addtop3(1,item.id)" @mouseout="addtop3(2,item.id)" style="overflow: hidden;width: 87%;">
            <div class="wen1" :class="item.zt?'add1':''" style="float: left;">
              <span class="span3" :class="item.zt?'add1':''">{{item.title}}</span>
            <span
                style="width: 16%;">({{item.downloads}})</span>
                 <!-- <span
                style="width: 16%;float: right;text-align: right;">({{item.downloads}})</span> -->
                </div>
          </div>
        </div>
      </div>
    </div>

<!-- 阅读排行 -->
  <div class="express_nav2" v-if="num.xia">
        <div class="express_rtitle">
            <div style="marginLeft:10px;">
            <img style="float:left"  src="../../../assets/ydph.png" alt="">
            </div>
          <div class="waikebb">阅读排行</div>
            <div style="float:right;lineHeight:30px;">
              更多>
          </div>
        </div>
        <div class="express_nav2r">
          <div class="express_list2" v-for="(item,index) in liu" :key="index" v-if="index<8" @click="jump(item.year,item.issue,item.id)">
            <div class="express_dian" :class="item.zt?'add2':''" @mouseover="addtop4(1,item.id)" @mouseout="addtop4(2,item.id)"></div>
            <div class="express_wen" @mouseover="addtop4(1,item.id)" @mouseout="addtop4(2,item.id)" style="overflow: hidden;width: 87%;">
              <div class="wen1" :class="item.zt?'add1':''" style="float: left;"><span class="span3" :class="item.zt?'add1':''">{{item.title}}</span>
              <span
                  style="width: 16%;">({{item.downloads}})</span>
                  </div>
            </div>
          </div>
        </div>
      </div>
    
    <!-- 浏览排行 -->

    <!-- <div class="express_nav2" v-if="num.look">
      <div class="express_rtitle">
        <div class="waike">浏览排行</div>
        <div class="waixian"></div>
      </div>
      <div class="express_nav2r">
        <div class="express_list2" v-for="(item,index) in liu" :key="index" v-if="index<8" @click="jump(item.year,item.issue,item.id)">
          <div class="express_dian" :class="item.zt?'add2':''" @mouseover="addtop3(1,item.id)" @mouseout="addtop3(2,item.id)"></div>
          <div class="express_wen" @mouseover="addtop3(1,item.id)" @mouseout="addtop3(2,item.id)" style="overflow: hidden;width: 87%;">
            <div class="wen1" :class="item.zt?'add1':''" style="float: left;"><span class="span3" :class="item.zt?'add1':''">{{item.title}}</span><span
                style="width: 16%;float: right;text-align: right;">({{item.downloads}})</span></div>
          </div>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
  export default {
    props: ['num', 'list2', 'title2', 'video'],
    data() {
      return {
        zixun: [],
        video2: [], //精彩视频
        titlePhoto: '',
        contentId: '',
        title3: '',
        xia: [], //下载排行
        xinxi:[],//最新信息
        liu: [], //浏览排行
        zixuntu: '',
        zixuntitle: '',
        zixunname: '',
        zixuncontentId: '',
        zixunchannelId: ''
      }
    },
    methods: {
      //跳转最新资讯详情页

      jumpzixun(num,contentId,channelId){
        console.log(num,contentId,channelId,'contentId,channelId')
        this.$router.push({path:'/expert_details',query:{num: num,contentId: contentId,channelId:channelId}});
      },
      //最新资讯
      GetHomePageBlockInfo2(channelId,jChannelID,dataSourceType){
        var that = this;
        that.$httphelper.GetHomePageBlockInfo({
          "journalId": that.$_JournalId,
          "pChannelId": 0,
          "channelId": channelId,
          "jChannelID": jChannelID,
          "dataSourceType": dataSourceType,
          "dataShowType": 1,
          "curr": 1,
          "limit": 7,
        }).then(res => {
          if(res.code==200){
            that.zixun = res.data || '';
            that.zixuntu = res.data[0].titlePhoto;
            that.zixuntitle = res.data[0].title;
            that.zixunname = res.data[0].organization;
            that.zixuncontentId = res.data[0].contentId ;
            that.zixunchannelId = res.data[0].channelId ;
            that.$loading.hideLoading();
          }else{
            that.$alert(res.msg, '提示', {
              confirmButtonText: '确定',
              callback: action => {

              }
            });
          }
        });
      },
      //下载 浏览排行
      GetJournalArticleList(id) {
        var that = this;
        that.$httphelper.GetJournalArticleList({
          "journalId": 201607080003,
          "queryType": id,
          "curr": 1,
          "limit": 8
        }).then(res => {
          if (res.code == 200) {
            if (id == 2) {
              that.xia = res.data || '';
            } else if(id==1) {
              that.liu = res.data || '';
            }else{
              that.xinxi=res.data || '';
            }
            that.$loading.hideLoading();
          } else {
            that.$alert(res.msg, '提示', {
              confirmButtonText: '确定',
              callback: action => {

              }
            });
          }
        });
      },
      jump(year,issue,issuecid){

         this.$router.push({path:'/browse_details',query:{year:year,issue:issue,issuecid:issuecid}});

      },

      jump1(channelId,contentId,num){
          console.log(channelId,contentId,num)
          // this.$router.push({path:'/expert_details',query:{num: num,contentId: contentId,channelId:channelId}});
         
      },
      jumpspxq(contentId) {
        this.$router.push({
          path: '/surgery_details',
          query: {
            contentId: contentId
          }
        });
      },
      jumpwai() {
        this.$router.push({
          path: '/surgery'
        });
      },
      jumpwai1() {
        this.$router.push({
          path: '/surgery_details'
        });
      },
      //精彩视频
      GetHomePageBlockInfo() {
        var that = this;
        that.$httphelper.GetHomePageBlockInfo({
          "pChannelId": 0,
          "channelId": 2816,
          "jChannelID": 0,
          "dataSourceType": 2,
          "dataShowType": 1,
          "journalId": that.$_JournalId,
          "curr": 1,
          "limit": 3,
        }).then(res => {
          if (res.code == 200) {
            that.video2 = res.data || '';
            if (that.video2) {
              that.titlePhoto = that.video2[0].titlePhoto;
              that.contentId = that.video2[0].contentId;
              that.title3 = that.video2[0].title;
            }
            that.$loading.hideLoading();
          } else {
            that.$alert(res.msg, '提示', {
              confirmButtonText: '确定',
              callback: action => {

              }
            });
          }
        });
      },
      //外科天地鼠标悬停
      addtop2(num, id) {
        if (num == 1) {
          for (var i = 0; i < this.list2.length; i++) {
            if (id == i) {
              this.list2[i].zt = true;
              this.list2.push('1');
              this.list2.pop('1');
            }
          }
        } else {
          for (var i = 0; i < this.list2.length; i++) {
            this.list2[i].zt = false;
            this.list2.push('1');
            this.list2.pop('1');
          }
        }
      },
      //下载排行鼠标悬停
      addtop3(num, id) {

        if (num == 1) {
          for (var i = 0; i < this.xia.length; i++) {
            if (id == this.xia[i].id) {
              this.xia[i].zt = true;
              this.xia.push('1');
              this.xia.pop('1');
            }
          }
        } else {
          for (var i = 0; i < this.xia.length; i++) {
            this.xia[i].zt = false;
            this.xia.push('1');
            this.xia.pop('1');
          }
        }
        
      },

    //信息公告鼠标悬停
      addtop33(num, id) {
        if (num == 1) {
          for (var i = 0; i < this.xinxi.length; i++) {
            if (id == this.xinxi[i].id) {
              this.xinxi[i].zt = true;
              this.xinxi.push('1');
              this.xinxi.pop('1');
            }
          }
        } else {
          for (var i = 0; i < this.xinxi.length; i++) {
            this.xinxi[i].zt = false;
            this.xinxi.push('1');
            this.xinxi.pop('1');
          }
        }
      },

      //浏览排行鼠标悬停
      addtop4(num, id) {
        if (num == 1) {
          for (var i = 0; i < this.liu.length; i++) {
            if (id == this.liu[i].id) {
              this.liu[i].zt = true;
              this.liu.push('1');
              this.liu.pop('1');
            }
          }
        } else {
          for (var i = 0; i < this.liu.length; i++) {
            this.liu[i].zt = false;
            this.liu.push('1');
            this.liu.pop('1');
          }
        }
      },
      //相关视频鼠标悬停
      addtop5(num, id) {
        if (num == 1) {
          for (var i = 0; i < this.video.length; i++) {
            if (id == this.video[i].id) {
              this.video[i].zt = true;
              this.video.push('1');
              this.video.pop('1');
            }
          }
        } else {
          for (var i = 0; i < this.video.length; i++) {
            this.video[i].zt = false;
            this.video.push('1');
            this.video.pop('1');
          }
        }
      },
      //精彩视频鼠标悬停
      addtop6(num, id) {
        if (num == 1) {
          for (var i = 0; i < this.video2.length; i++) {
            if (id == i) {
              this.video2[i].zt = true;
              this.video2.push('1');
              this.video2.pop('1');
            }
          }
        } else {
          for (var i = 0; i < this.video2.length; i++) {
            this.video2[i].zt = false;
            this.video2.push('1');
            this.video2.pop('1');
          }
        }
      },
      //最新资讯鼠标悬停
      addtop7(num, id) {
        if (num == 1) {
          for (var i = 0; i < this.zixun.length; i++) {
            if (id == i) {
              this.zixun[i].zt = true;
              this.zixun.push('1');
              this.zixun.pop('1');
            }
          }
        } else {
          for (var i = 0; i < this.zixun.length; i++) {
            this.zixun[i].zt = false;
            this.zixun.push('1');
            this.zixun.pop('1');
          }
        }
      },
    },
    created() {
      //最新资讯
      this.GetHomePageBlockInfo2(2823,1,1);
      //精彩视频
      this.GetHomePageBlockInfo();
      //下载排行
      this.GetJournalArticleList(2);
      //浏览排行
      this.GetJournalArticleList(1);
      //最新信息
      this.GetJournalArticleList(3);
    }
  }
</script>

<style lang="scss" scoped>
  .express_right {
    width: 100%;
    margin-bottom: 48px;

    .express_rtitle {
      width: 100%;
      overflow: hidden;
      border-bottom: 3px solid #DBDBDB;
      position: relative;

      .waike {
        width: 50%;
        float: left;
        font-size: 20px;
        font-family: Source Han Sans SC;
        font-weight: bold;
        color: #000000;
        line-height: 23px;

       
      }

      .zi {
        width: 50%;
        float: right;
        text-align: right;
        font-size: 14px;
        font-family: Source Han Sans SC;
        font-weight: bold;
        color: #878787;
        line-height: 23px;
        cursor: pointer;
      }

      .waixian {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 81px;
        height: 3px;
        background: var(--biao);
      }
    }

    .express_rxia {
      width: 100%;

      .express_rimg {
        width: 100%;
        height: 199px;
        margin-top: 20px;
        margin-bottom: 27px;
        cursor: pointer;
      }

      .express_rimg:hover {
        transform: scale(1.05);
      }

      .express_rtxt {
        font-size: 18px;
        font-family: Adobe Heiti Std;
        font-weight: bold;
        color: #000000;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        cursor: pointer;
      }

      .express_rlist {
        width: 100%;
        overflow: hidden;
        margin-top: 30px;
        margin-bottom: 21px;
        cursor: pointer;

        .express_dian {
          width: 10px;
          height: 10px;
          background: #DBDBDB;
          border-radius: 50%;
          margin-right: 15px;
          float: left;
          margin-top: 6px;
       

        }

        .wenben {
          width: 85%;
          float: left;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          font-size: 16px;
          font-family: Adobe Heiti Std;
          font-weight: normal;
          color: #000000;
        }
      }
    }
  }

  .Journalism_one {
    width: 100%;
    margin-bottom: 48px;

    .express_rtitle {
      width: 100%;
      overflow: hidden;
      border-bottom: 3px solid #DBDBDB;
      padding-bottom: 11px;
      position: relative;

      .waike {
        width: 50%;
        float: left;
        font-size: 20px;
        font-family: Source Han Sans SC;
        font-weight: bold;
        color: #000000;
        line-height: 23px;
        
      }

      .zi {
        width: 50%;
        float: right;
        text-align: right;
        font-size: 14px;
        font-family: Source Han Sans SC;
        font-weight: bold;
        color: #878787;
        line-height: 23px;
        cursor: pointer;
      }

      .waixian {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 81px;
        height: 3px;
        background: var(--biao);
      }
    }

    .Journalism_onebottom {
      width: 100%;
      overflow: hidden;
      margin-top: 19px;

      .Journalism_list {
        width: 100%;
        overflow: hidden;
        margin-bottom: 26px;

        .Journalism_listl {
          width: 38%;
          height: 119px;
          float: left;
          cursor: pointer;
        }

        .Journalism_listl:hover {
          transform: scale(1.05);
        }

        .Journalism_listr {
          width: 53%;
          float: left;
          margin-left: 4%;

          a {
            font-size: 18px;
            font-family: Adobe Heiti Std;
            font-weight: bold;
            text-decoration: underline;
            line-height: 28px;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
          }

          a:hover {
            color: var(--xt) !important;
          }

          .listr_xia {
            width: 100%;
            margin-top: 30px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;

            span {
              width: 100%;
              font-size: 14px;
              font-family: Adobe Heiti Std;
              font-weight: normal;
              color: #757575;
              line-height: 28px;
            }
          }
        }
      }

      .Journalism_list2 {
        width: 100%;
        overflow: hidden;
        margin-bottom: 22px;

        .Journalism_list2id,
        .Journalism_list2id2 {
          width: 5%;
          max-width: 20px;
          height: 20px;
          background: #E34919;
          border-radius: 50%;
          text-align: center;
          line-height: 20px;
          float: left;
          margin-right: 15px;
          color: #FFFFFF;
          margin-left: 2%;
        }

        .Journalism_list2id2 {
          background-color: #D2D2D2;
        }

        .kandian {
          line-height: 20px;
          float: left;
          font-size: 16px;
          font-family: Adobe Heiti Std;
          font-weight: bold;
          color: #000000;
          margin-right: 10px;
        }

        .Journalism_list2txt {
          width: 80%;
          font-size: 16px;
          line-height: 20px;
          font-family: Adobe Heiti Std;
          color: #000000;
          float: left;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          cursor: pointer;
        }
      }
    }
  }

  .express_nav2 {
    width:270px;
    margin-bottom: 48px;
    // border: 1px solid #ccc;
    box-shadow: 1px 2px 6px 2px #ccc;

    .express_rtitle {
      width: 270px;
      overflow: hidden;
      // border-bottom: 3px solid #DBDBDB;
      padding-bottom: 11px;
      position: relative;
      top: 15px;

      .waike {
        width: 50%;
        float: left;
        font-size: 20px;
        font-family: Source Han Sans SC;
        font-weight: bold;
        color: #000000;
        line-height: 30px;
      }
      .waikeaa{
          width: 50%;
        float: left;
        font-size: 20px;
        font-family: Source Han Sans SC;
        font-weight: bold;
        color: red;
        line-height: 30px;
        text-align: center;
      }
      .waikebb{
        width: 50%;
        float: left;
        font-size: 20px;
        font-family: Source Han Sans SC;
        font-weight: bold;
        color: orange;
        line-height: 30px;
        text-align: center;
      }
      .waikebb{
        width: 50%;
        float: left;
        font-size: 20px;
        font-family: Source Han Sans SC;
        font-weight: bold;
        color: skyblue;
        line-height: 30px;
        text-align: center;
      }

      .waixian {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 81px;
        height: 3px;
        background: var(--biao);
      }
    }

    .express_nav2r {
      width: 100%;
      overflow: hidden;
      margin-top: 29px;

      .express_list2 {
        width: 100%;
        overflow: hidden;
        cursor: pointer;
        margin-left: 16px;
        margin-bottom: 12.3px;

        .express_dian {
          width: 10px;
          height: 10px;
          background: #2A2D3E;
          margin-right: 6px;
          float: left;
          margin-top: 6px;
        clip-path: polygon(50% 0,100% 50%,50% 100%,0 50%);
        transition:1s clip-path;
        }

        .express_wen {
          width: 80%;
          float: left;

          .wen1 {
            width: 100%;
            font-size: 16px;
            font-family: Adobe Heiti Std;
            font-weight: normal;
            color: #000000;
            margin-bottom: 12.2px;

            // .span3 {
            //   width: 83%;
            //   white-space: nowrap;
            //   text-overflow: ellipsis;
            //   overflow: hidden;
            //   float: left;
            // }

             .span4 {
              width: 83%;
              white-space: nowrap;
              text-overflow: ellipsis;
              overflow: hidden;
              float: left;
            }
          }
          .wen11{
               width: 110%;
            font-size: 16px;
            font-family: Adobe Heiti Std;
            font-weight: normal;
            color: #000000;
            margin-bottom: 12.2px;
            .span4 {
              width: 83%;
              white-space: nowrap;
              text-overflow: ellipsis;
              overflow: hidden;
              float: left;
            }
          }

          .wen2 {
            width: 100%;
            font-size: 14px;
            font-family: Adobe Heiti Std;
            font-weight: normal;
            color: #636363;
            margin-bottom: 10px;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
          }
        }

        .zhai {
          width: 95%;
          padding-left: 31px;
          overflow: hidden;
          float: left;

          .wen3 {
            width: 50%;
            font-size: 14px;
            font-family: Adobe Heiti Std;
            font-weight: normal;
            color: #636363;
            float: left;
          }

          .zhai_left,
          .zhai_right {
            font-size: 14px;
            font-family: Adobe Heiti Std;
            font-weight: normal;
            color: #000000;
            float: right;
          }

          .zhai_right {
            margin-left: 30px;
          }

          .zhai_left:hover {
            text-decoration: underline;
            color: var(--biao);
          }

          .zhai_right:hover {
            text-decoration: underline;
            color: var(--biao);
          }
        }
      }

      .express_list2:last-child {
        margin-bottom: 0;
      }
    }
  }

  .surgery_video {
    width: 100%;
    margin-bottom: 48px;

    .express_rtitle {
      width: 100%;
      overflow: hidden;
      border-bottom: 3px solid #DBDBDB;
      padding-bottom: 11px;
      position: relative;

      .waike {
        width: 50%;
        float: left;
        font-size: 20px;
        font-family: Source Han Sans SC;
        font-weight: bold;
        color: #000000;
        line-height: 23px;
      }

      .zi {
        width: 50%;
        float: right;
        text-align: right;
        font-size: 14px;
        font-family: Source Han Sans SC;
        font-weight: bold;
        color: #878787;
        line-height: 23px;
        cursor: pointer;
      }

      .waixian {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 81px;
        height: 3px;
        background: var(--biao);
      }
    }

    .surgery_bottom {
      width: 100%;
      margin-top: 20px;

      img {
        width: 100%;
        height: 199px;
        object-fit: cover;
      }

      img:hover {
        transform: scale(1.03);
      }

      .surgery_bottom1 {
        width: 100%;
        margin-bottom: 27px;
        cursor: pointer;

        .surgery_bottomtxt {
          width: 100%;
          font-size: 18px;
          font-family: Adobe Heiti Std;
          font-weight: bold;
          color: #000000;
          line-height: 28px;
          white-space: nowrap; //强制字体不换行
          text-overflow: ellipsis; //超出字体隐藏
          overflow: hidden;
          margin-top: 23px;
          margin-bottom: 12px;
        }

        .surgery_bottomtxt2 {
          width: 100%;
          overflow: hidden;

          .surgery_one,
          .surgery_two {
            width: 50%;
            float: left;
            font-size: 14px;
            font-family: Adobe Heiti Std;
            font-weight: normal;
            color: #757575;
            line-height: 28px;
          }

          .surgery_two {
            text-align: right;
          }
        }
      }
    }
  }

  .express_right {
    width: 100%;
    padding-top: 30px;
    background-color: #FFFFFF;
    padding-bottom: 15px;

    .express_rtitle {
      width: 90%;
      margin: 0 auto;
      overflow: hidden;
      border-bottom: 3px solid #DBDBDB;
      position: relative;

      .waike {
        width: 50%;
        float: left;
        font-size: 20px;
        font-family: Source Han Sans SC;
        font-weight: bold;
        color: #000000;
        line-height: 23px;
        border-bottom: 3px solid var(--xt);
      }

      .zi {
        width: 50%;
        float: right;
        text-align: right;
        font-size: 14px;
        font-family: Source Han Sans SC;
        font-weight: bold;
        color: #878787;
        line-height: 23px;
        cursor: pointer;
      }

      .waixian {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 81px;
        height: 3px;
        background: var(--biao);
      }
    }

    .express_rxia {
      width: 90%;
      margin: 0 auto;

      .express_rimg {
        width: 100%;
        height: 199px;
        margin-top: 25px;
        margin-bottom: 30px;
        cursor: pointer;
      }

      .express_rimg:hover {
        transform: scale(1.05);
      }

      .express_rtxt {
        font-size: 18px;
        font-family: Adobe Heiti Std;
        font-weight: bold;
        color: #000000;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        cursor: pointer;
      }

      .express_rlist {
        width: 100%;
        overflow: hidden;
        margin-top: 30px;
        margin-bottom: 21px;
        cursor: pointer;

        .express_dian {
          width: 10px;
          height: 10px;
          background: #DBDBDB;
          border-radius: 50%;
          margin-right: 15px;
          float: left;
          margin-top: 6px;
        }

        .wenben {
          width: 85%;
          float: left;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          font-size: 16px;
          font-family: Adobe Heiti Std;
          font-weight: normal;
          color: #000000;
        }
      }
    }
  }

  .add1 {
    color: var(--xt) !important;
    text-decoration: underline;
  }

  .add2 {
    background-color: var(--xt) !important;
  }

  .cao{
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
  }
</style>



// WEBPACK FOOTER //
// src/components/public/evolution/advertisement.vue